const UNIVERSAL = {
  // BASEURL: "https://www.laravel.crm.softvalley.net/",
  // BASEURL: "https://crm.mahbub.design/",
  // BASEURL: "https://dreamint.softvalley.net/",
  // BASEURL: "http://crm.new.sveducrm.com/",  //adept
  // BASEURL: "https://crm.softvalley.sveducrm.com/", //main
  //BASEURL: "https://alt.crm.softvalley.sveducrm.com/", //main
  //BASEURL: "https://api.crm.dreamstudyinternational.com/", //dream study
  // BASEURL: "http://127.0.0.1:8000/", //dream study
  BASEURL: "https://api.marketing.sveducrm.com/", //marketing
  ENCRYPTION_KEY: "#_2023_MARUF_SVCRM",
  JWT_SECRET: "",
};
export default UNIVERSAL;
